const ProfilesList = ({ data }) => {
  const { titulo, perfiles, seccion, columnas } = data

  return (
    <>
      {titulo && (
        <div className="bg-blue text-white text-[48px] lg:text-[60px] pl-14 py-4 lg:py-8">
          <p>{titulo}</p>
        </div>
      )}
      <div>
        <div>
          <div className="bg-sec-grey-4 text-blue text-[22px] lg:text-[28px] font-alliance-medium pl-14 py-4 mb-8">
            <p>{seccion}</p>
          </div>
          <div
            className={`pl-14 pr-14 mt-6 mb-6 bg-white grid gap-4 grid-cols-1 lg:grid-cols-${
              columnas || 4
            } `}
          >
            {perfiles.map((profile, idx) => {
              const imgs = profile?.imagen.data?.attributes.formats
              const img = imgs?.thumbnail || imgs?.small || imgs?.medium
              return (
                <div
                  key={idx}
                  className="flex mb-4 border-b border-sec-grey-50"
                >
                  <div className="pr-6 lg:mt-2 pb-4 lg:pb-8">
                    <div className="w-24 h-24 rounded-full overflow-hidden">
                      <img
                        className="object-cover"
                        src={img?.url || '/assets/images/players/no-photo.svg'}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 pb-8 gap-0">
                    <div className="text-blue font-alliance-medium self-end ${profile?.className">
                      {profile?.nombre}
                    </div>
                    <div className="text-sec-grey-30 self-start">
                      {profile?.puesto}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfilesList
